import $, { ajax } from "jquery";

const branchLocator = {
  selectedCity: null,
  getAllCities: null,
  branchID: null,
  cityAddressData: null,
  shareLabel: $(".branch__locator").data("share-label"),
  branchAddressLabel: $(".branch__locator").data("branchAddressLabel"),
  laoderEle: $('.branch__locator'),
  cityImage: [
    "color_purple",
    "color_yellow",
    "color_pink",
    "color_orange",
    "color_blue",
    "color_green",
    "color_red",
    "color_turquoise",
  ],
  bindEvents() {
    $("#cityInput").off("input").on("input", (event) => this.handleCityInput(event));
    $(document).off("click", "#searchResults li").on("click", "#searchResults li", (event) =>
      this.handleCitySelection(event)
    );
    $(document).off("click", ".branch__locator__city__link").on("click", ".branch__locator__city__link", (event) =>
      this.handleCityLinkClick(event)
    );
  },
  handleCityInput: function (event) {
    const searchQuery = $(event.target).val().toLowerCase().trim();
    const $searchResults = $("#searchResults");
    $searchResults.empty();
    if (!searchQuery) {
      this.appendData(false);
    }
    if (searchQuery !== "") {
      const matchedCities = branchLocator?.getAllCities?.value
        ?.filter((city) => city.toLowerCase().includes(searchQuery))
        .map((city) => `<li class="city__search__results--item" >${city}</li>`);
      $searchResults.append(matchedCities);
    }
  },
  handleCitySelection(event) {
    const citySelected = $(event.target).text();
    $("#cityInput").val(citySelected);
    $("#searchResults").empty();
    this.selectedCity = citySelected;
    this.fetchBranchAddress(branchLocator.selectedCity, branchLocator.branchID);
  },
  handleCityLinkClick(event) {
    event.preventDefault();
    this.selectedCity = $(event.currentTarget).attr("data-city");
    $("#cityInput").val(this.selectedCity);
    const branchID = $(event.currentTarget).find('.branch__locator').attr("data-branch-id");
    this.fetchBranchAddress(branchLocator.selectedCity, branchLocator.branchID);
  },
  appendData(filterByCity) {
    const $containerNew = $(".branch__locator__card");
    $containerNew.empty();

    let hasData = false;
    if(Array.isArray(branchLocator.cityAddressData)){
      branchLocator?.cityAddressData?.forEach((item) => {
        if (
          !filterByCity ||
          item.city.toLowerCase() === this.selectedCity.toLowerCase()
        ) {
          const innerDivHTML = this.generateInnerHTML(item);
          $containerNew.append(innerDivHTML);
          hasData = true;

        }
      });
    }

    if (!hasData) {
      $containerNew.html(
        `<p class="font-20 text-center">${$(".branch__locator").data(
          "noResultMessage"
        )}</p>`
      );
    }

    this.handleShare();
  },

  generateInnerHTML(item) {
    const titleText = item.companyName.trim();
    return `
            <div class="branch__locator__card__inner h-100 w-100 p-5 border d-flex justify-content-between align-items-start flex-column ${
              titleText == "HSBC Bank" ? "hsbc__bank__color border-red-300" : ""
            }
            ${
              titleText == "Canara Bank"
                ? "canara__bank__color border-yellow-300"
                : ""
            } ${
      titleText == "Canara HSBC Life Insurance"
        ? "canara__hsbc__color border-blue-400"
        : ""
    }">
                <div class="w-100">
                    <div class="d-flex justify-content-between align-items-start">
                        <div class="d-flex flex-column align-items-start">
                            <h3 class="font-20 font-lg-24 branch__name mb-2 fw-bold">${
                              item.companyName
                            }</h3>
                            <div class="branch__location d-flex align-items-center">
                                <span class="branch__location--icon me-2 d-flex align-items-center justify-content-center">
                                    <svg aria-hidden="true" class="location_icon w-100 h-100 ${
                                      titleText == "HSBC Bank"
                                        ? "text-red-300"
                                        : ""
                                    }
                                        ${
                                          titleText == "Canara Bank"
                                            ? "text-yellow-300"
                                            : ""
                                        } ${
      titleText == "Canara HSBC Life Insurance" ? "text-blue-400" : ""
    }">
                                        <use xlink:href="/etc.clientlibs/chli/clientlibs/clientlib-site/resources/images/sprite/sprite.svg#location"/>
                                    </svg>
                                </span>
                                <span class="text-black-400 font-body">${
                                  item.city
                                }</span>
                            </div>
                        </div>
                        <div class="branch__logo ms-8 d-flex align-items-center justify-content-end">
                            ${
                              titleText == "HSBC Bank"
                                ? `<svg aria-hidden="true" class="w-100 h-100">
                                                            <use xlink:href="/etc.clientlibs/chli/clientlibs/clientlib-site/resources/images/sprite/sprite.svg#logo-hsbc"/>
                                                        </svg>`
                                : ""
                            }
                            ${
                              titleText == "Canara Bank"
                                ? `<svg aria-hidden="true" class="w-100 h-100">
                                                            <use xlink:href="/etc.clientlibs/chli/clientlibs/clientlib-site/resources/images/sprite/sprite.svg#logo-canara"/>
                                                        </svg>`
                                : ""
                            }
                            ${
                              titleText == "Canara HSBC Life Insurance"
                                ? `<svg aria-hidden="true" class="w-100 h-100">
                                                            <use xlink:href="/etc.clientlibs/chli/clientlibs/clientlib-site/resources/images/sprite/sprite.svg#logo-canara-hsbc"/>
                                                        </svg>`
                                : ""
                            }
                        </div>
                    </div>
                    <h4 class="branch__address mt-2 fw-medium font-20 lh-28">${
                      this.branchAddressLabel
                    }</h4>
                    <p class="branch__full__address font-body mt-2">${
                      item.branchAddress
                    }</p>
                </div>
                <a href="#social-share-section" class="branch__address__share d-flex align-items-center mt-4">
                    <span class="branch__address__share--icon me-2 d-flex align-items-center justify-content-center">

                    <svg aria-hidden="true" class="share__icon ${
                      titleText == "HSBC Bank" ? "text-red-300" : ""
                    }
                            ${
                              titleText == "Canara Bank"
                                ? "text-yellow-300"
                                : ""
                            } ${
      titleText == "Canara HSBC Life Insurance" ? "text-blue-400" : ""
    }">
                            <use xlink:href="/etc.clientlibs/chli/clientlibs/clientlib-site/resources/images/sprite/sprite.svg#share"/>
                        </svg>

                    </span>
                    <span class="text-black-400 font-body">${
                      this.shareLabel
                    }</span>
                </a>
            </div>`;
  },
  handleAllCity: function (response) {
    branchLocator.getAllCities = response;
    if (!branchLocator.cityAddressData) {
      this.appendData(false);
    }
  },
  fetchCityData: async function () {
    try {
      const response = await $.ajax({
        type: "POST",
        url: "/bin/chli/getAllCity",
        contentType: "application/json",
        dataType: "json"
      });
      branchLocator.handleAllCity(response);
    } catch (error) {
      // Handled failure (list just stays empty): warn, not error.
      console.warn("AJAX error:", error);
    }
  },
  handleBranchAddress: function (response) {
    branchLocator.cityAddressData = response;
    this.appendData(!this.selectedCity);
  },
  fetchBranchAddress: async function (location, branchID) {
    branchLocator.handleLoader(branchLocator.laoderEle, true);
    const url = branchID ? "/bin/chli/getBranchAddress?branchID=" + branchID : "/bin/chli/getBranchAddress";
    try {
      const response = await $.ajax({
        type: "POST",
        url: url,
        contentType: "application/json",
        dataType: "json",
        data: JSON.stringify({ cityName: location }),
      });
      branchLocator.handleLoader(branchLocator.laoderEle, false);
      branchLocator.handleBranchAddress(response);
    } catch (error) {
      branchLocator.handleLoader(branchLocator.laoderEle, false);
      // Handled failure (loader hidden, list stays empty): warn, not error.
      console.warn(error);
    }
  },

  addClasses: function () {
    let cityCard = $(".branch__locator__city__list");
    cityCard.each(function (index) {
      $(this).addClass(branchLocator.cityImage[index]);
    });
  },

  handleShare: function() {

    $('.branch__address__share').off("click").on("click", async function () {
      let val = $(this).parent().find('.branch__full__address').text();

      if (navigator.share) {
        try {
          await navigator.clipboard.writeText(val);

          await navigator.share({
            text: val,
          });
        } catch (error) {
          console.log("Error sharing:", error);
        }
      } else {
        alert("Web Share API is not supported in your Browser.");
      }

      let buttonName = $(this).closest('.branch__locator__card__inner').find('.branch__address__share .font-body').text().trim();
      let cardInner = $(this).closest('.branch__locator__card__inner');
      let cityName = cardInner.find('.branch__location').text().trim();
      let eventObj = {
        buttonText: buttonName,
        city: cityName
      };
      let section = $(this).closest('.branch__locator');
      let title = section.find('.heading-4').text().trim();
      let obj = branchLocator.dataLayerObj(eventObj, title);
      createDataLayer('buttonClick', obj);

    });
  },

  handleLoader: function(loader, isAdd) {
    const parentLoad = $(loader).find('.spinning-loader');
    const sectionContainer = $(loader).find('.branch__locator--cards-container');
    if (isAdd) {
      sectionContainer.addClass('loading__section');
      sectionContainer.append(parentLoad);
      $(parentLoad).removeClass('d-none').addClass('inside-section-loader');
      sectionContainer.css('position', 'relative');
    } else {
      sectionContainer.removeClass('loading__section');
      $(parentLoad).addClass('d-none');
      $(loader).find('.spinning-loader').removeClass('inside-section-loader').addClass('d-none');
    }
  },

  buttonClickHandler: function() {
    $('.branch__locator .section_container--primary').off('click', '.branch__locator__city__link').on('click', '.branch__locator__city__link', function() {
      let buttonName = $(this).find('.city__name').text().trim();
      let eventObj = { buttonText: buttonName };
      let section = $(this).closest('.branch__locator');
      let titleText = section.find('.heading-4').text().trim();
      let obj = branchLocator.dataLayerObj(eventObj, titleText);
      createDataLayer('buttonClick', obj);
    });
  },

  searchClickedHandler: function() {
    $('.branch__locator .search__city__name').off('focus').on('focus', function() {
      let term = $(this).val();
      let eventObj = { searchTerm: term };
      let section = $(this).closest('.branch__locator');
      let titleText = section.find('.heading-4').text().trim();
      let obj = branchLocator.dataLayerObj(eventObj, titleText);
      createDataLayer('searchClicked', obj);
    });
  },
  searchCityResultClickHandler: function() {
    $(document).off('click', '.city__search__results .city__search__results--item').on('click', '.city__search__results .city__search__results--item', function(e) {
      const parentEle = $(this).parents('.city__search__results');
      let term = $(this).text().trim();
      let eventObj = { searchTerm: term };
      let section = parentEle.closest('.branch__locator');
      let titleText = section.find('.heading-4').text().trim();
      let obj = branchLocator.dataLayerObj(eventObj, titleText);
      createDataLayer('enter_search_autosuggestions', obj);
    });
  },

  searchKeywordHandler: function() {
    let timeout;
    $('.branch__locator .search__city__name').off('keyup').on('keyup', function() {
      const $this = $(this);
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        let term = $this.val();
        let eventObj = { searchTerm: term };
        let section = $this.closest('.branch__locator');
        let titleText = section.find('.heading-4').text().trim();
        let obj = branchLocator.dataLayerObj(eventObj, titleText);
        createDataLayer('enter_search_keyword', obj);
      }, 3000);
    });
  },
               dataLayerObj: function (e,el) {
                    var obj = {
                        'articleName': "",
                        'blogCategory': "",
                        'blogPageCategory': "",
                        'buttonText': e.buttonText ? e.buttonText : "",
                        'pageSection': el ? el : "Branch Locator",
                        'pageType': document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? window.location.href.includes("blog") ? "Blogs" : window.location.href.substring(window.location.href.indexOf(".com/"), window.location.href.length) === ".com/" ? "Home" : "Other Pages" : "Blog Details Page",
                        'planOption': "",
                        'productCategory': "",
                        'productName': "",
                        'question': "",
                        'source': "",
                        'searchTerm': e.searchTerm ? e.searchTerm : "",
                        'videoTitle': "",
                        'bannerName': "",
                        'cityName': e.city ? e.city : ""
                    };
                    return obj;
                },


  init() {
    if ($(".branch__locator").length > 0) {
      this.branchID = $(".branch__locator").data("branch-id");
      this.bindEvents();
      this.addClasses();
      this.buttonClickHandler();
      this.searchClickedHandler();
      this.searchKeywordHandler();
      this.searchCityResultClickHandler();
      const defaultCity = $(".default__city").data("defaultCity");
      if (defaultCity) {
        this.selectedCity = defaultCity;
        this.fetchBranchAddress(defaultCity, this.branchID);
      }
      setTimeout(() => {
        this.fetchCityData();
      }, 100);
    }
  },
};

$(document).ready(function () {
  branchLocator.init();
});
